import { FilterTabs } from "@components/pageHeader/filters/lib";

export const INVOICE_PAGE_FILTER_TABS: FilterTabs[] = [
    FilterTabs.INVOICE_DATE,
    FilterTabs.EXTERNAL_INVOICE_STATUSES,
    FilterTabs.INVOICE_STATUSES,
    FilterTabs.OVERDUE,
    FilterTabs.AMOUNT,
    FilterTabs.ACCOUNT,
    FilterTabs.CATALOG_ITEM,
    FilterTabs.INVOICE_SOURCE_TEMPLATE,
    FilterTabs.SUBSCRIPTION,
    FilterTabs.MATCH_STATUS,
    FilterTabs.COUNTERPARTY,
    FilterTabs.INVOICE_TERMS,
    FilterTabs.INVOICE_SENT_STATUS,
];
